import React, { useState } from 'react';

import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

function RoleTitleDropdown({ currentRoleId, currentRoleTitle = 'Choose a Role', items = [], setCurrentRoleId = () => null }) {
  const [isOpen, setIsOpen] = useState(false);
  
  const toggleIsOpen = () => setIsOpen(() => !isOpen);

  const handleOnItemClick = (event) => {
    const roleId = event.currentTarget.getAttribute('data-role-id');

    if (roleId === currentRoleId) return;

    setCurrentRoleId(roleId)
    console.log(roleId)
  }


  return (
    <ButtonDropdown isOpen={isOpen} toggle={toggleIsOpen}>
        <DropdownToggle caret outline color="link" className="fs-5 fw-normal text-light shadow-none  rounded-0 border-0 border-bottom border-2 border-primary-orange px-0">
            {currentRoleTitle}
        </DropdownToggle>

        <DropdownMenu>
            {items.map(({ roleId, title, sections = [] }) => (
                <DropdownItem 
                    key={`role-item-${roleId}`}
                    data-role-id={roleId}
                    className={`role-item ${roleId === currentRoleId ? 'active' : ''}`}
                    onClick={handleOnItemClick}
                >
                    {title}
                </DropdownItem>
            ))}
        </DropdownMenu>
    </ButtonDropdown>
  )
}

export default RoleTitleDropdown